import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToastContext } from "components/alert/ToastContext";
import BaseListagem from "components/BaseListagem";
import ReportEdit from "components/reports/ReportEdit";
import saveAs from 'file-saver';
import Veiculo from "model/gestao/frotas/Veiculo";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { SplitButton } from "primereact/splitbutton";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ItemManutencaoVeiculoService from "service/gestao/frotas/ItemManutencaoVeiculoService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterData } from "utils/convert";
import { DateMatchModeOptions, IdMatchModeOptions, ListMatchModeOptions, NumberMatchModeOptions, TextMatchModeOptions, dateRangeFilterTemplate, filterApplyTemplate, numberFilterTemplate } from "utils/filterUtils";

const itemManutencaoVeiculoService = new ItemManutencaoVeiculoService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function ItemManutencaoVeiculoListagem() {

    const [queryParameters] = useSearchParams();

    const { msgErro } = useToastContext();

    const [veiculos, setVeiculos] = useState<Veiculo[]>([]);

    const [titulo, setTitulo] = useState<string>('Itens de Manutenção');

    const [editaRelatorio, setEditaRelatorio] = useState<boolean>(false);
    const [visibleEditarRelatorio, setVisibleEditarRelatorio] = useState<boolean>(false);

    const { startLoading, stopLoading } = useLoadingContext();

    const navigate = useNavigate();

    useEffect(() => {
        itemManutencaoVeiculoService.veiculosDisponiveis().then(data => setVeiculos(data)).catch(erro => console.log(erro));
    }, [])

    const statusFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <MultiSelect value={options.value} options={itemManutencaoVeiculoService.getStatusManutencaoVeiculoFilter()}
            onChange={(e: MultiSelectChangeEvent) => options.filterCallback(e.value)}
            optionLabel="label" optionValue="value" placeholder="Qualquer" className="p-column-filter"
        />;
    };

    const tipoFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <MultiSelect value={options.value} options={itemManutencaoVeiculoService.getTipoManutencaoVeiculoFilter()}
            onChange={(e: MultiSelectChangeEvent) => options.filterCallback(e.value)}
            optionLabel="label" optionValue="value" placeholder="Qualquer" className="p-column-filter"
        />;
    };

    const defaultFilters: DataTableFilterMeta = {
        tipo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },

        dataManutencao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },

        veiculo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        itemInspecao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        descricaoInspecao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        valor: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);

    const veiculoFilterTamplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={veiculos} filter
            onChange={(e) => options.filterCallback(e.value)}
            itemTemplate={(item: Veiculo) => item.identificador + ' - ' + item.modelo}
            valueTemplate={(item: Veiculo) => item ? item.identificador + ' - ' + item.modelo : 'Escolha um veículo'}
            optionLabel={"modelo"} optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const editar = (id: number) => {
        let url = `/manutencaoVeiculo/editar/${id}`;
        navigate(`${url}`);
    }

    return (
        <>
            <BaseListagem
                ordenacao="manutencaoVeiculo.dataManutencao,DESC"
                service={itemManutencaoVeiculoService}
                urlService="/itemManutencaoVeiculo"
                tituloPagina={titulo}
                defaultFilters={defaultFilters}
                showClearFilterButton
                showEditButton={false}
                showNewButton={false}
                showRemoveButton={false}
                nome="itemManutencaoVeiculo"
                onChangeFilters={(filters) => setFilters(filters)}>
                <Column field="tipo" header="Tipo" filterField="tipo" body={(rowData) => itemManutencaoVeiculoService.getTipo(rowData.manutencaoVeiculo.tipo)} style={{ width: '10%' }}
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={tipoFilterTemplate} />

                <Column field="manutencaoVeiculo.dataManutencao" header="Data" filterField="dataManutencao" body={(rowData) => converterData(rowData.manutencaoVeiculo.dataManutencao)} style={{ width: '10%' }}
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={dateRangeFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />

                <Column field="veiculo" header="Veiculo" body={(rowData) => rowData.manutencaoVeiculo.veiculo.identificador + " - " + rowData.manutencaoVeiculo.veiculo.modelo} style={{ width: '40%' }} filterField="veiculo"
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={veiculoFilterTamplate} />

                <Column field="status" header="Status" body={(rowData) => itemManutencaoVeiculoService.getStatus(rowData.manutencaoVeiculo.status)} style={{ width: '10%' }}
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={statusFilterTemplate} />

                <Column field="veiculoItemInspecao.itemInspecao.nome" filterField="itemInspecao" header="Nome do Item" style={{ width: '10%' }} filterPlaceholder="Escreva o filtro"
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}/>

                <Column field="descricaoInspecao" header="Descricão do Item"body={(rowData) => rowData.manutencaoVeiculo.tipo == "CORRETIVA"? rowData.descricao : rowData.descricaoInspecao} style={{ width: '10%' }} filterPlaceholder="Escreva o filtro"
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />

                <Column field="valor" header="Valor" body={(rowData) => rowData.valor ? "R$" + rowData.valor.toFixed(2) : "R$0,00"} style={{ width: '10%' }}
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} filterElement={numberFilterTemplate} />

                <Column key="colOpcoes" style={{ whiteSpace: 'nowrap', width: '7em' }} body={(rowData) =>
                    <div>
                        <Button type="button" icon={<FontAwesomeIcon icon="edit" />} className="ui-button-info" onClick={() => editar(rowData.manutencaoVeiculo.id)}></Button>
                    </div>}
                />
            </BaseListagem>
        </>

    )
}